<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请人部门：" :value="headInfo.applyDept" :options="applyDeptOptions"></hi-cell>
    <hi-cell title="申请人所在采购组织：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="认定申请类型：" :value="headInfo.identifyApplyType" :options="identifyApplyTypeOptions"></hi-cell>
    <hi-cell title="供货品类：" :value="headInfo.catgName"></hi-cell>
    <hi-cell title="申请原因：" :value="headInfo.applyReason" :options="applyReasonOptions"></hi-cell>
    <hi-cell v-if="isShow" title="硬件委员会副主任：" :value="headInfo.hardwareCommitteeName"></hi-cell>
    <div style="position: relative">
      <hi-cell v-if="isShow" title="研发认定工程师：" :value="headInfo.devUserName" @click.native="onClick"></hi-cell>
      <span class="star" v-if="isShowStar">*</span>
    </div>
    <hi-cell title="质量工程师：" :value="headInfo.quaUserName"></hi-cell>
    <hi-cell title="采购组长：" :value="headInfo.purUserName"></hi-cell>
    <hi-cell title="要求完成日期：" :value="headInfo.reserveDate"></hi-cell>
    <hi-cell
      title="是否需要审厂："
      :value="headInfo.isFactoryAuditReport"
      :options="isFactoryAuditReportOptions"
    ></hi-cell>
    <hi-cell
      title="是否淘汰恢复认定："
      :value="headInfo.isRecoverEliminate"
      :options="isRecoverEliminateOptions"
    ></hi-cell>
    <hi-cell title="申请原因：" :value="headInfo.urgentDescribe"></hi-cell>
    <hi-cell title="现有供方不能满足原因：" :value="headInfo.describeExt"></hi-cell>
    <van-dialog v-model="show" show-cancel-button title="研发认定工程师" @confirm="onConfirm" @cancel="onCancel">
      <div class="dialog-content">
        <div class="content-cell" v-for="(item, index) in columns" :key="index" @click="clickCell(item, index)">
          <div class="title">{{ item.userName }}</div>
          <div class="right">
            <van-checkbox :value="item.selected"></van-checkbox>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { supplierApplyInfo } from '@/api/supplierApplyPicker'
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {
      columns: [],
      show: false,
      su: {}
    }
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    },
    taskDefinitionKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 认定申请类型为“代理商认定”时，“硬件委员会副主任”和“研发认定工程师”字段不展示
    isShow() {
      return this.headInfo.identifyApplyType !== '00'
    },
    isShowStar() {
      return (
        this.headInfo.identifyApplyType === '01' &&
        (this.taskDefinitionKey === 'Activity_12a1w9w' || this.taskDefinitionKey === 'Activity_0agfue3')
      )
    },
    applyDeptOptions() {
      return this.$store.getters.dicts.person_to_apply
    },
    identifyApplyTypeOptions() {
      return this.$store.getters.dicts.identify_apply_type
    },
    applyReasonOptions() {
      return this.$store.getters.dicts.willing_to_apply
    },
    isFactoryAuditReportOptions() {
      return this.$store.getters.dicts.yes_no
    },
    isRecoverEliminateOptions() {
      return this.$store.getters.dicts.yes_no
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const columnsResp = await supplierApplyInfo({ limit: '1000', userType: 'inner', groupCode: 'RDGCS' })
      this.columns = columnsResp.data.rows
    },
    onClick() {
      // 如果当前节点是“硬件委员会审核节点”，显示弹窗
      if (this.taskDefinitionKey === 'Activity_12a1w9w' || this.taskDefinitionKey === 'Activity_0agfue3') {
        this.show = true
      }
    },
    clickCell(item) {
      this.columns.forEach(e => this.$set(e, 'selected', false))
      this.$set(item, 'selected', true)
      this.su = item
    },
    onConfirm() {
      this.show = false
      if (!this.su.userName) {
        return
      }
      this.$set(this.headInfo, 'devUserName', `${this.su.userName}`)
      this.$set(this.headInfo, 'devUserId', this.su.userId)
    },
    onCancel() {
      this.show = false
    }
  }
}
</script>

<style scoped>
.star {
  position: absolute;
  left: 5px;
  top: 12px;
  color: red;
  font-size: 17px;
}
.dialog-content {
  height: 40vh;
  overflow: scroll;
}
.content-cell {
  display: flex;
  padding: 10px 16px;
  font-size: 16px;
  color: #333333;
  border-bottom: 1px solid #ececec;
}
.title {
  flex: 1;
}
.right {
  width: 30px;
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
